import moment from 'moment';
import {get} from 'lodash';
import schema from './transaction_db';
import * as utils from "./utils";
import {edit} from './sample';
import i18n from 'src/i18n/index';
import * as Member from './membership';
import debug from 'src/debug';
import sweetalert from 'sweetalert2';

export function title(model) {
  if (model) {
    return `${moment(get(model, 'created_at')).format('YYYY-MM-DD HH:mm:ss')} (From ${Member.title.call(this, model.from, Member)} to ${Member.title.call(this, model.to, Member)})`;
  } else {
    return i18n.s('schema.transaction');
  }
}

export const columns = utils.columnsFn(schema);

export const list = utils.listFn('getTransactions');
export const view = utils.viewFn('/admin/transactions/:id');
export const read = utils.readFn('getTransactionById', 'transaction_id');

export {edit};

export function formActions(model, schema, readonly) {
  let temp = [];
  if (!readonly) {
    if (model && model.type === 'caregiver_invoice'
      && ['waiting_admin_confirm', 'pending'].includes(model.transaction_progress)) {
      temp.push({
        label: i18n.fr('action.complete_invoice'),
        class: 'btn-success',
        async action(model, schema, columns) {
          let self = this;
          return sweetalert({
            html: i18n.fr('alert.html.confirm_complete_invoice'),
            type: 'warning',
            showCancelButton: true,
            confirmButtonText: i18n.fr('action.yes'),
            cancelButtonText: i18n.fr('action.cancel'),
            confirmButtonClass: 'btn btn-danger btn-fill',
            cancelButtonClass: 'btn btn-fill',
            buttonsStyling: false,
          }).then(() => {
            return utils.updateFn('updateTransaction', 'transaction_id', ['transaction_progress'],
              payload => {
                payload.transaction_progress = 'success';
                return payload;
              }).call(self, model, schema, columns);
          }, () => false);
        },
      });
    }
    temp.push({
      label: i18n.fr('action.save') + ' [Ctrl+Enter]',
      trigger: e => (e.metaKey || e.ctrlKey) && e.keyCode === 13,
      class: 'btn-success',
      validation: true,
      action: utils.updateFn('updateTransaction', 'transaction_id', [
        'transaction_progress',
        'status',
        'remark',
      ]),
    });
    if (debug.DEBUG) {
      temp.push({
        label: i18n.s('action.delete') + ' [Del]',
        class: 'btn-danger',
        trigger: e => e.keyCode === 46,
        action: utils.formActions.delete('deleteTransactionById', 'transaction_id', '/admin/transactions'),
      });
    }
  }
  temp.push(utils.formActions.back);
  return temp;
}

export function listActions(schema, readonly) {
  let temp = [];
  temp.push({
    label: i18n.fr('action.create_$obj', {obj: '${i18n.schema.standalone_transaction}'}),
    class: 'btn-success',
    action: utils.createFn('/admin/transactions/standalone?type=standalone'),
  });
  temp.push({
    label: i18n.fr('action.create_$obj', {obj: '${i18n.schema.rapid_payment}'}),
    class: 'btn-success',
    action: utils.createFn('/admin/transactions/standalone?type=rapid'),
  });
  return temp;
}



// WEBPACK FOOTER //
// ./src/schemas/transaction.js